/*!
 * Copyright 2023 Quisitive Technologies, LLC. All rights reserved.
 */
import React, { useEffect } from 'react';

import { get, values } from 'lodash';
import Element from '../../../../components/element';
import Flex from '../../../../components/flex';
import Text from '../../../../components/text';
import NoData from '../../NoData';
import { create, updateData } from '../../Chart/DistributionChart/chart';

const Dexterity = ({ healthReportData }) => {
  useEffect(() => {
    const dexterityList = values(healthReportData.dexterity);
    dexterityList.map(each => {
      const data = { ...each, section: 'dexterity', chartVal: each.value };
      const settings = {
        el: each.display_label && each.display_label.replace(/ /g, '_'),
        margin: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      };
      create(settings);
      updateData(data);
    });
  }, []);
  return (
    <Element>
      {get(healthReportData, 'dexterity.dominant.value') === null &&
        get(healthReportData, 'dexterity.non_dominant.value') === null ? (
        <NoData />
      ) : (
        <Element>
          <Element>
            <Text family="GTAM" size="14px" color="#222222" width="830px">
              Dexterity is a person’s ability to coordinate the fingers and
              manipulate objects in a timely manner. Dexterity improves with age
              through childhood, and declines beyond age 60.
            </Text>
          </Element>
          <Flex align="center" marginTop="50px">
            <Element width="250px">
              <Text
                family="GTAM"
                size="16px"
                color="#222222"
                marginBottom="30px"
              >
                Dominant Hand
              </Text>
            </Element>
            <Element marginRight="70px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {/* {get(healthReportData, 'dexterity.dominant.percentile')}% */}
                {Math.floor(
                  Number(
                    get(healthReportData, 'dexterity.dominant.percentile')
                  ) * 10
                ) /
                  10 +
                  '%' || 0 + '%'}
              </Text>
              <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                Percentile
              </Text>
            </Element>
            <div
              id={get(
                healthReportData,
                'dexterity.dominant.display_label'
              ).replace(/ /g, '_')}
              style={{ width: '25.58%' }}
            ></div>
          </Flex>
          <Flex align="center" marginTop="70px">
            <Element width="250px">
              <Text
                family="GTAM"
                size="16px"
                color="#222222"
                marginBottom="30px"
              >
                Non-Dominant Hand
              </Text>
            </Element>
            <Element marginRight="70px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {/* {get(healthReportData, 'dexterity.non_dominant.percentile')}% */}
                {Math.floor(
                  Number(
                    get(healthReportData, 'dexterity.non_dominant.percentile')
                  ) * 10
                ) /
                  10 +
                  '%' || 0 + '%'}
              </Text>
              <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                Percentile
              </Text>
            </Element>
            <div
              id={get(
                healthReportData,
                'dexterity.non_dominant.display_label'
              ).replace(/ /g, '_')}
              style={{ width: '25.58%' }}
            ></div>
          </Flex>
        </Element>
      )}
    </Element>
  );
};

export default Dexterity;
